/**
 * The five archetypes (PRD §3.2).
 *
 * "The single field that makes the engine general-purpose without a rewrite."
 * The archetype determines outcome semantics and routing defaults — and, from
 * Story 2.3, which Verdict sentence a band produces. It is deliberately a
 * closed enum: a sixth archetype is a product decision, not a config value.
 */
import { z } from 'zod'

export const ARCHETYPES = [
  'scorecard',
  'qualifier',
  'recommender',
  'triage',
  'eligibility',
] as const

export const archetypeSchema = z.enum(ARCHETYPES)
export type Archetype = z.infer<typeof archetypeSchema>

/**
 * What each archetype's outcome page leads with (PRD §3.2, verbatim from the
 * table). Read by the Verdict composer (Story 2.3) and the outcome renderer
 * (Story 5.8) so the two cannot disagree about what a `triage` funnel is for.
 */
export const ARCHETYPE_OUTCOME: Record<Archetype, string> = {
  scorecard: 'Score + band + benchmark',
  qualifier: 'Qualified / not + next step',
  recommender: 'Recommended option or tier',
  triage: 'Assigned destination',
  eligibility: 'Yes / no + reason',
}
